import { Badge, Box, Stack, Text } from "@chakra-ui/react"

const statusColor = (status) => ({ OK: "green", ERROR: "red" }[status] || "gray")

// Content of the info window: every location at that pin (usually one), with its group,
// broadcast and devices. `devicesByLocation` maps a location id to its devices.
export default function LocationInfo({ locations, devicesByLocation }) {
  return (
    <Stack spacing={3} maxW="300px" color="gray.700">
      {locations.map((location, index) => {
        const broadcast = location.broadcast || location.group?.broadcast
        const devices = devicesByLocation[location.id] || []
        return (
          <Box key={location.id} pt={index > 0 ? 3 : 0} borderTopWidth={index > 0 ? "1px" : 0}>
            <Text fontWeight="bold" fontSize="md">{location.name}</Text>
            <Text fontSize="sm">{[location.address, location.city].filter(Boolean).join(", ") || "No address"}</Text>
            {location.telephone && <Text fontSize="sm" color="gray.600">Tel: {location.telephone}</Text>}
            {location.workingHours && <Text fontSize="sm" color="gray.600">Hours: {location.workingHours}</Text>}
            <Text fontSize="sm" color="gray.600">Group: {location.group?.name || "None"}</Text>
            <Text fontSize="sm" color="gray.600">Broadcast: {broadcast?.name || "None"}</Text>
            <Stack direction="row" wrap="wrap" mt={1} spacing={1}>
              {devices.length === 0
                ? <Badge fontSize="0.7em">No device</Badge>
                : devices.map(device => (
                  <Badge key={device.id} fontSize="0.7em" colorScheme={statusColor(device.status)}>{device.code || device.id}</Badge>
                ))}
            </Stack>
          </Box>
        )
      })}
    </Stack>
  )
}
